module.exports = __webpack_public_path__ + "static/media/happy.a808e4c8.svg";